module.exports = "/packs/images/homepage/whatson/learn_to_swim_mobile~b640699c0f998fd241aed66d33e8e347.jpg";